import React from 'react';

interface InvestorGuaranteeShieldProps {
  className?: string;
}

/** Green shield with checkmark — matches Figma "Shield green no background" (Investor LP). */
const InvestorGuaranteeShield: React.FC<InvestorGuaranteeShieldProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="30-day money-back guarantee"
  >
    <path
      d="M12 2.75 5 5.75v5.75c0 3.95 2.98 7.42 7 8.5 4.02-1.08 7-4.55 7-8.5V5.75L12 2.75z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.75 12.25 11 14.5l4.25-4.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default InvestorGuaranteeShield;
